import React, { useEffect, useRef } from 'react';
import './ChangeRequestDetailScreen.less';
import ChangeRequestInput from '../../components/ChangeRequest/ChangeRequestInput/ChangeRequestInput';
import ChangeRequestTitle from '../../components/ChangeRequest/ChangeRequestTitle/ChangeRequestTitle';
import ChangeRequestSteps from '../../components/ChangeRequest/ChangeRequestSteps/ChangeRequestSteps';
import Meta from '../../components/Meta';
import { useParams, useNavigate } from 'react-router-dom';
import { getChangeRequest } from '../../app/ActionTypes/changeRequestActionTypes';
import { useSelector } from 'react-redux';
import { useAgentDispatch } from '../../hooks/useAgentStore';
import { RootState } from '../../app/store';
import { updateCurrentStep } from '../../app/Slices/changeRequestStepsSlice';
import { resetChangeRequest } from '../../app/Slices/changeRequestSlice';
import {
  setChangeRequestId,
  setRevokeAPICalls,
} from '../../app/Slices/changeRequestStateSlice';
import { Notify } from '../../services/notificationService';
import { AppRoutes } from '../../constants/route';
import ActionError from '../../utils/ActionError';

const ChangeRequestDetailScreen: React.FC = () => {
  const { changeRequestRouteId } = useParams<{
    changeRequestRouteId: string;
  }>();
  const agentDispatch = useAgentDispatch();
  const navigate = useNavigate();
  const org = useSelector((state: RootState) => state.organization.org);
  const sfOrgIdIntialized = useRef<string | null>(null);

  useEffect(() => {
    initializeState();
    return () => {
      agentDispatch(setRevokeAPICalls(true));
    };
  }, [changeRequestRouteId]);

  useEffect(() => {
    if (org?.id && !sfOrgIdIntialized.current) {
      initializeState();
    }
  }, [org?.id]);

  const initializeState = async () => {
    if (changeRequestRouteId && org?.id) {
      sfOrgIdIntialized.current = org.id;
      agentDispatch(resetChangeRequest());
      agentDispatch(updateCurrentStep(0));
      agentDispatch(setChangeRequestId(changeRequestRouteId));
      try {
        await agentDispatch(getChangeRequest(changeRequestRouteId)).unwrap();
      } catch (error) {
        if ((error as ActionError).statusCode === 404) {
          Notify.error('Change Request not found');
          navigate(AppRoutes.changeRequests.path, { replace: true });
        }
      }
    }
  };

  return (
    <>
      <Meta name="Cirra AI - Change Request Detail" />
      <ChangeRequestTitle />
      <div id="change-request" data-testid="change-request">
        <div>
          <ChangeRequestInput />
          <ChangeRequestSteps />
        </div>
      </div>
    </>
  );
};

export default ChangeRequestDetailScreen;
